import React from 'react';
import { Form, Input, Button, message } from 'antd';
import { useNavigate } from 'react-router-dom';
import { FormInstance } from 'antd/lib/form';
import { changePassword } from '../../api';
import styles from '../Login/index.module.css';

const ChangePasswordPage: React.FC = () => {
  const formRef = React.createRef<FormInstance>();
  const navigate = useNavigate();

  const onFinish = async (values: any) => {
    try {
      const response = await changePassword(values.currentPassword, values.newPassword);
      if (response.status === 200) {
        const result = await response.json();
        if (result.success) {
          message.success('密碼已成功更改！');
          navigate('/');
        } else {
          message.error(result.message || '更改密碼失敗，請重試。');
        }
      } else {
        message.error('更改密碼失敗，請檢查當前密碼是否正確。');
      }
    } catch (err) {
      console.error('Change password error:', err);
      message.error('更改密碼時發生錯誤，請稍後再試。');
    }
  };

  return (
    <div style={{ 
      minHeight: 'calc(100vh - 80px)', 
      display: 'flex', 
      alignItems: 'center', 
      justifyContent: 'center',
      padding: '32px',
    }}>
      <div style={{ 
        width: '100%', 
        maxWidth: 480, 
        backgroundColor: '#ffffff',
        borderRadius: '12px',
        padding: '32px',
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.06)',
      }}>
        <h2 style={{ 
          marginTop: 0, 
          marginBottom: '24px',
          fontSize: '26px',
          fontWeight: '700',
          color: '#1a1a1a',
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
        }}>更改密碼</h2>
        <Form
        ref={formRef}
        name="changePassword"
        onFinish={onFinish}
        initialValues={{
          currentPassword: '',
          newPassword: '',
          confirmPassword: '',
        }}
        scrollToFirstError
      >
        <Form.Item
          name="currentPassword"
          rules={[
            {
              required: true,
              message: '請輸入當前密碼！',
            },
          ]}
          hasFeedback
        >
          <Input.Password placeholder="當前密碼" size="large" />
        </Form.Item>

        <Form.Item
          name="newPassword"
          rules={[
            {
              required: true,
              message: '請輸入新密碼！',
            },
            {
              min: 4,
              message: '密碼長度至少為4個字符！',
            },
          ]}
          hasFeedback
        >
          <Input.Password placeholder="新密碼" size="large" />
        </Form.Item>

        <Form.Item
          name="confirmPassword"
          dependencies={['newPassword']}
          hasFeedback
          rules={[
            {
              required: true,
              message: '請確認新密碼！',
            },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || getFieldValue('newPassword') === value) {
                  return Promise.resolve();
                }
                return Promise.reject(new Error('兩次輸入的密碼不一致！'));
              },
            }),
          ]}
        >
          <Input.Password placeholder="確認新密碼" size="large" />
        </Form.Item>

        <Form.Item>
          <Button 
            type="primary" 
            htmlType="submit" 
            style={{ 
              width: '100%',
              height: '44px',
              fontSize: '16px',
              fontWeight: '600',
              background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
              border: 'none',
              boxShadow: '0 4px 12px rgba(102, 126, 234, 0.4)',
            }}
          >
            更改密碼
          </Button>
        </Form.Item>
        
        <Form.Item>
          <Button 
            type="link" 
            onClick={() => navigate('/')} 
            style={{ 
              width: '100%',
              color: '#667eea',
              fontWeight: '500',
            }}
          >
            返回首頁
          </Button>
        </Form.Item>
        </Form>
      </div>
    </div>
  );
};

export default ChangePasswordPage;
